import { render, staticRenderFns } from "./VImagePopup.vue?vue&type=template&id=3a2b54f0&"
import script from "./VImagePopup.vue?vue&type=script&lang=ts&"
export * from "./VImagePopup.vue?vue&type=script&lang=ts&"
import style0 from "./VImagePopup.vue?vue&type=style&index=0&id=3a2b54f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports